import { useEffect, useState } from 'react';

 const useJutroMFESdk = submissionIntakeURL => {
    const [loaded, setLoaded] = useState(false);
    useEffect(() => {
        let hasChanged = false;
        const [, url] = submissionIntakeURL.split('@');
        const script = document.createElement('script');
        script.setAttribute('data-jutro-mfe-sdk', 'true');
        script.onload = () => {
            if (!hasChanged) {
                setLoaded(true);
            }
        };
        script.src = `${url}/jutro-micro-frontends.js`;
        document.head.appendChild(script);
        return () => {
            hasChanged = true;
            document.head.removeChild(script);
        };
    }, [setLoaded, submissionIntakeURL]);
    // @ts-ignore
    return loaded ? window.JutroMicroFrontends : null;
};

export default useJutroMFESdk
